import styled from "@emotion/styled";
import CustomTextInput from "@components/input/CustomTextInput";
import BasicButton from "@components/button/BasicButton";
import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import BackHeader from "@components/header/BackHeader";

const AddressSearch = () => {
  const { setValue, watch } = useFormContext();
  const [isEmbedOpen, setIsEmbedOpen] = useState(false);
  useEffect(() => {
    if (isEmbedOpen) {
      new window.daum.Postcode({
        oncomplete: function (data: any) {
          let fullAddress = data.address;

          // 건물명이 있으면 추가
          if (data.buildingName) {
            fullAddress += ` (${data.buildingName})`;
          }

          setValue("postcode", data.zonecode);
          setValue("address", fullAddress);

          setIsEmbedOpen(false);
        },
      }).embed(document.getElementById("postcode-embed"));
    }
  }, [isEmbedOpen, setValue]);

  const handlePostcodeSearch = () => {
    setIsEmbedOpen(true); // iframe 열기
  };

  const handlePostcodeBackButton = () => {
    setIsEmbedOpen(false);
  };

  const country = watch("country");

  return (
    <AddressContainer>
      <InputWrapper>
        <CustomTextInput
          type="text"
          placeholder="우편번호"
          name="postcode"
          readOnly={country === "KR"}
          fontSize="1.6rem"
          max={100}
        />

        {country === "KR" && (
          <BasicButton
            title="주소검색"
            height="5.2rem"
            width="9.6rem"
            padding="1.6rem 1.2rem"
            onClick={handlePostcodeSearch}
            type="button"
          />
        )}
      </InputWrapper>

      <CustomTextInput
        type="text"
        placeholder="주소"
        name="address"
        readOnly={country === "KR"}
        fontSize="1.6rem"
        max={500}
      />

      {/* country값이 없거나 KR이면 상세주소 렌더링 */}
      {(country === "" || country === "KR") && (
        <CustomTextInput
          type="text"
          placeholder="상세주소"
          name="address_detail"
          fontSize="1.6rem"
          max={500}
        />
      )}

      {isEmbedOpen && (
        <>
          <EmbedContainer>
            <BackHeader title="주소검색" onClick={handlePostcodeBackButton} />
            <div id="postcode-embed" />
          </EmbedContainer>
        </>
      )}
    </AddressContainer>
  );
};

export default AddressSearch;

const AddressContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const InputWrapper = styled.div({
  display: "flex",
  gap: "1rem",
});

const EmbedContainer = styled.div({
  width: "100%",
  height: "100vh",
  position: "fixed",
  top: "0",
  left: "0",
  background: "white",
  zIndex: "9999",
});
